/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Misa_Template_StaleInputs */

const vi_invoice_misa_template_stale = /** @type {(inputs: Invoice_Misa_Template_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mẫu đã lưu không còn trong danh sách đang hoạt động. Chọn mẫu khác để tiếp tục lập hóa đơn, hoặc lưu nguyên cài đặt để kiểm tra sau.`)
};

/**

* @param {Invoice_Misa_Template_StaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const invoice_misa_template_stale = /** @type {((inputs?: Invoice_Misa_Template_StaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Misa_Template_StaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_invoice_misa_template_stale(inputs)
});